<template>
  <div class="block">
    <el-carousel height="150px"  :interval="4000">
      <el-carousel-item >
        <img src="../assets/header1.jpg" style="object-fit: contain;" />
      </el-carousel-item>
       <el-carousel-item >
        <img src="../assets/header2.jpg" style="object-fit: contain;" />
      </el-carousel-item>
      <el-carousel-item >
        <img src="../assets/header3.jpg" style="object-fit: contain;" />
      </el-carousel-item>
      <el-carousel-item >
        <img src="../assets/header4.jpg" style="object-fit: contain;" />
      </el-carousel-item>
      <el-carousel-item >
        <img src="../assets/header5.jpg" style="object-fit: contain;" />
      </el-carousel-item>
      <el-carousel-item >
        <img src="../assets/header6.jpg" style="object-fit: contain;" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        activeName: '1',
        
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/HeaderContent.vue